/**
* @ComponentFor Avensia.Shop.Features.Category.Commerce.CategoryViewModel
*/
import React from 'react';
import { translate } from 'Shared/translate';
import ProductListing from 'Shared/ProductListing';
import Main, { Section } from 'Shared/PageLayout';
import { epiPropertyValue, EpiProperty } from '@avensia/nitro5-scope-episerver';
import Description from 'Shared/Description';
import ContentCardRow from 'Shared/ContentCardRow';
import { MEDIUM, SMALL } from 'Shared/breakpoints';
import DescriptionImage from 'Shared/DescriptionImage/DescriptionImage';
import ProductCarousel from 'Shared/Blocks/ProductCarousel/ProductCarouselBlock';
import * as styles from './base.scss';
import CategoryPageHeader from './Components/CategoryHeader';
import CategoryHero from './Components/CategoryHero';
import connect from 'Shared/connect';
class Category extends React.Component {
    constructor(props) {
        super(props);
        this.ads = props.supplierAds;
        this.state = {
            subCategories: this.props.products.subCategories
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.ads = nextProps.supplierAds;
        if (!!nextProps.products.subCategories) {
            this.setState({
                subCategories: nextProps.products.subCategories
            });
        }
    }
    getActiveConcept() {
        if (!!!this.props.products.conceptFacets)
            return null;
        if (this.props.products.conceptFacets.map(c => c.facetValueSettings).length == 0)
            return null;
        const facetSettings = this.props.products.conceptFacets.map(c => c.facetValueSettings)
            .reduce((acc, settings) => acc.concat(settings))
            .filter(function (value, index, self) {
            return index === self.findIndex(function (x) {
                return x.original && x.original.id === value.original.id;
            });
        });
        return !!facetSettings && !!facetSettings.length ?
            facetSettings.find(x => !!x.original.selected) : null;
    }
    render() {
        return (React.createElement(Main, { appearance: "narrow", className: styles.main },
            !!epiPropertyValue(this.props.content.topContent) && (React.createElement(Section, null,
                React.createElement(EpiProperty, { for: this.props.content.topContent }))),
            React.createElement(Section, { className: styles.bottomBorder },
                this.props.currentBreakpoint >= MEDIUM && !!this.props.heroAds && this.props.heroAds.length > 0 && (React.createElement(CategoryHero, { hero: this.props.heroAds[0] })),
                !!epiPropertyValue(this.props.content.middleContent) && (React.createElement(Section, null,
                    React.createElement(EpiProperty, { for: this.props.content.middleContent }))),
                !!this.props.description && !!this.props.imageUrl && this.props.currentBreakpoint >= MEDIUM && (React.createElement(DescriptionImage, { text: this.props.description, imageUrl: this.props.imageUrl })),
                !!this.props.text && (React.createElement(Description, { text: this.props.text, hasShowAllButton: false, centered: true, lineCount: "few", expandFromUrl: true })),
                React.createElement(CategoryPageHeader, { newsBannerArea: this.props.newsBannerContentArea, headerProperty: this.props.content.displayName, breadcrumbs: this.props.breadcrumbs, categories: this.state.subCategories, activeConcept: this.getActiveConcept() })),
            React.createElement(ProductListing, Object.assign({}, this.props, { disableHeaderRow: true, showLayoutOptions: this.props.currentBreakpoint > SMALL, recommendationsPanel: this.props.recommendationsPanel })),
            this.ads.map((data) => (React.createElement(ProductCarousel, Object.assign({ key: data.title }, data)))),
            React.createElement(ContentCardRow, { cards: this.props.cards, title: translate('/Product/LatestNews') })));
    }
}
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
}))(Category);
